<template>
  <div class="page-class page-setting-list">
    <div class="page-title text-center">
      <h2>Petty Cash - Expense Setting</h2>
      <h6>Manage the monthly expense creation period</h6>
    </div>
    <feedback-list-box
      :columns="columns"
      :rows="settings"
      :loading="loading"
      :showAdd="false"
      :showFilter="false"
      :showToolbar="false"
      :searchItems="searchItems"
      addText="Create Expense Setting"
      emptyText="No expense settings found."
      @add="onAdd"
      @edit="onEdit"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FeedbackListBox from '../../../components/FeedbackListBox.vue';

export default {
  name: 'ExpenseSettingList',
  components: { FeedbackListBox },
  data() {
    return {
      searchItems: ['Company'],
      columns: [
        { type: 'row_num', headerText: '#', class: { 'text-center': true }, textKey: 'rowNum', width: '10%' },
        { type: 'string', headerText: 'Company', class: { 'text-center': true }, textKey: 'company', width: '25%' },
        { type: 'string', headerText: 'Allowed From', class: { 'text-center': true }, textKey: 'expenseRequestBlockFrom', width: '25%' },
        { type: 'string', headerText: 'Allowed To', class: { 'text-center': true }, textKey: 'expenseRequestBlockTo', width: '25%' },
        { type: 'functions', headerText: 'Functions', class: { 'text-center': true }, width: '15%', functions: { edit: true } }
      ]
    };
  },
  computed: { ...mapState('expenseRequestBlock', ['loading', 'settings']) },
  mounted() {
    this.list({ router: this.$router });
  },
  methods: {
    ...mapActions('expenseRequestBlock', ['list']),
    onAdd() {
      this.$router.push('/petty-cash/expense-setting/new');
    },
    onEdit({ row }) {
      this.$router.push(`/petty-cash/expense-setting/${row.id}`);
    }
  }
};
</script>
